export default "__VITE_ASSET__BrJwpFKK__"